import React from 'react';
import sIcon1 from '../../images/icons/pencil-paintbrush_result.webp'
import sIcon2 from '../../images/icons/code-window_result.webp'
import sIcon3 from '../../images/icons/bullseye-arrow_result.webp'

const Policy = [
  {
    title: 'Designing',
    subTitle: 'Creative and user-friendly designs.',
    icon: sIcon1,
  },
  {
    title: 'Development',
    subTitle: 'Robust and scalable applications.',
    icon: sIcon2,
  },
  {
    title: 'Marketing',
    subTitle: 'Data-driven growth strategies.',
    icon: sIcon3,
  },
];




const PolicySection = (props) => {

    return (
        <section className="policy_section">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block layout_icon_left">
                                <div className="iconbox_icon bg-secondary-subtle">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;